<template lang="pug">
div.score-box
	.cap-rating(v-if="isCaps" onclick="void(0)" :class="`${score}`")
		b-img-lazy(:src="`//web-resources.savingforcollege.com/images/cap-ratings/rating-caps-${score}.svg`" fluid)
	.star-img(v-if="!isCaps && score != null && score != 0" )
		b-img-lazy(:src="`//web-resources.savingforcollege.com/images/${score}-Star.svg`" fluid)

	div(v-if="showCount")
		div(v-if="isCaps")
			.count(v-if="score != 'NP' && score != 'NO'") {{score}} of 5
		div(v-else)
			.count(v-if="score") {{score}} of 5
			.count.no-padding(v-else) N/A

</template>

<style lang="stylus" scoped>
	@import '../assets/css/variables.styl';

	.cap-rating
		background-position: left center
		&.4A
		&.5A
		&.3A
			height: 30px
		&.NO
			// background-image: url("https://web-resources.savingforcollege.com/images/cap-ratings/rating-caps-NO.svg") !important
			height: 30px
		&.NP
			// background-image: url("https://web-resources.savingforcollege.com/images/cap-ratings/rating-caps-NP.svg") !important
			height: 30px

	.cap-rating
	.star-img
		display: block
		height: 21px
		width: 115px
		margin-top: 5px
		max-width: 90%
		padding: 0
		margin: 0
		img
			position: relative
			top: -3px
			width: 100%
		&.NO
		&.NP
			img
				top: 4px

	.count
		text-align: left

	.count
		font-size: body-font-size-md
		font-weight: body-font-weight
		padding-top: 10px
		&.no-padding
			padding-top: 0
	@media (max-width: 768px)
		.count
			padding-bottom: 15px

</style>
<script>
import Vue from 'vue'
import { BImgLazy } from 'bootstrap-vue'
Vue.component('b-img-lazy', BImgLazy)
export default {
	props: {
		showCount:{
			type: Boolean,
			default: true
		},
		score:{
			default: '0'
		},
		isCaps :{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
		}
	}
}
</script>
